import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { searchTextState } from '../../redux/workLocations'

class SearchField extends Component {

  handleOnKeyUp = () => {
    this.props.search(this.refs.searchInput.value)
    this.props.dispatch(searchTextState(this.refs.searchInput.value))
    this.props.callback()
  }

  componentDidMount() {
    if (this.props.workLocations && this.props.workLocations.previousSearchText) {
      this.setValue(this.props.workLocations.previousSearchText)
    } else {
      this.setValue("")
    }
  }

  setValue(value) {
    ReactDOM.findDOMNode(this.refs.searchInput).value = value
    this.props.search(value)
  }

  render() {
    return (
      <input
        ref='searchInput'
        className='form-control'
        type='text'
        defaultValue={this.props.defaultValue}
        placeholder="Enter Work Location details..."
        onKeyUp={this.handleOnKeyUp} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    workLocations: state.workLocations
  }
}

export default connect(mapStateToProps, null, null, { withRef: true })(SearchField)


// WEBPACK FOOTER //
// ./src/modules/Work Locations/Components/TableCustomComponents/SearchField.js